import React from "react";
import Popover from "../../../../../components/popover/Popover";

export default function ChannelModeHelp({ buttonClassName }: {buttonClassName?: string}) {
    return (
        <Popover buttonClassName={buttonClassName} title="Channel Menu Help">
            <ul>
                <li>
                    Threaded mode will create a new ticket for each message in the main channel.
                </li>
                <li>
                    &quot;One ticket at a time&quot; mode will create a ticket from the first message in
                    a channel, then treat the channel as a single ticket until the ticket is closed. Once the ticket
                    is closed in Agent, a new message in the channel will create a new thread.
                </li>
                <li>
                    Manual mode will only create tickets when triggered by other means such as emoji actions.
                </li>
            </ul>
        </Popover>
    );
}

ChannelModeHelp.defaultProps = {
    buttonClassName: "",
};
